import { gql } from "lib/apolloClient";

export const getPermissionsQuery = gql`
  query getPermissionsQuery($filters: ACLPermissionsFilterInput) {
    platform {
      aclControlParameters(filters: $filters) {
        uid
        module
        controlParameters {
          id
          value
          permission
          uid
        }
      }
    }
  }
`;
